exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2VlZYYKI6NcV_Z2SYFb3VS{width:100%}._2t16LNmDgPXb-ZG1cJ8X18{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:600;letter-spacing:.07143rem;line-height:1.125;margin:0;padding-bottom:.71429rem}._1KeysdMgXZHBBRVkSCynLz{min-height:2.5rem}@media only screen and (min-width:480px){._3YSxMriUFnFIUYRBmKTZ7S{padding-right:1.42857rem}}@media only screen and (min-width:640px){._3YSxMriUFnFIUYRBmKTZ7S{padding-right:2.14286rem}}._33FqebRZsvULpmLdhHqabI{padding-bottom:.71429rem}.snAPyXOo3qoziYpC6RqPZ{padding-bottom:1.07143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillSuggestionCard_board": "_2VlZYYKI6NcV_Z2SYFb3VS",
	"SkillSuggestionCard_h5": "_2t16LNmDgPXb-ZG1cJ8X18",
	"SkillSuggestionCard_select_option": "_1KeysdMgXZHBBRVkSCynLz",
	"SkillSuggestionCard_item": "_3YSxMriUFnFIUYRBmKTZ7S",
	"SkillSuggestionCard_skillResult": "_33FqebRZsvULpmLdhHqabI",
	"SkillSuggestionCard_skillResult_indexLabel": "snAPyXOo3qoziYpC6RqPZ"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/FeedbackSuggestions/SkillSuggestionCard/style.postcss
// module id = 1781
// module chunks = 0